import { Card } from '@ipfabric/ui-components/Card/Card';
import type { ReactNode } from 'react';
import type { UseFormReturn } from 'react-hook-form';
import type { DeviceCredentialsFieldValues } from '../../snippets/storedDeviceCredentials';
import { SearchableSection } from '../DiscoverySearch/SearchableSection';

type Props = {
  form: UseFormReturn<DeviceCredentialsFieldValues>;
  renderSnippet: (name: 'storedDeviceCredentials') => ReactNode;
};

export const DeviceCredentials = (props: Props) => (
  <Card className='flex flex-col flex-1 rounded-tl-none' noShadow>
    <SearchableSection
      className='flex flex-col flex-1 p'
      wrapperClassName='flex flex-col flex-1'
      id='device-credentials'
      highlightOn={['authentication']}
    >
      {props.renderSnippet('storedDeviceCredentials')}
    </SearchableSection>
  </Card>
);
